module.exports = "<div style=\"margin:0 auto\"\r\n    max-width=\"lg\"\r\n    ui-view>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/template.html
// module id = 3144
// module chunks = 0